import React, { Component } from "react";
import ChatBox from "./../../components/ChatBox/ChatBox";

class LayoutPage extends Component {
  render() {
    const { Component } = this.props;
    // console.log(this.props);
    return (
      <>
        <Component {...this.props} />
        <ChatBox />
      </>
    );
  }
}

export default LayoutPage;
